module.exports = __webpack_public_path__ + "img/ticket-template-placeholder.32379c14.png";